<script>

import useValidation from "@/use/Validation";
import useSharedData from "@/use/SharedData";
import useSharedSelectData from "@/use/SharedSelectData";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import {useRoleStore} from "@/stores/Setting/Role";
import {computed, onMounted, ref} from "vue";
import axios from "axios";

export default {
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        viewAction: Boolean,
        deleteAction: Boolean,
    },
    setup(props) {
        const readonly = computed(() => props.deleteAction || props.viewAction);
        
        const {mxRules} = useValidation();
        const {dialog, loading, overlay, inputColor, backgroundColor} = useSharedData();
        const {roleTypes} = useSharedSelectData();
        const {getBack} = useSharedMethod();
        const {$refs, $route} = useTools();
        const roleStore = useRoleStore();
        const role = ref({
            primary: false,
        });
        
        function findById(id) {
            loading.value = true;
            axios.get(`/roles/${id}`).then((response) => {
                role.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.post('/roles', role.value).then((response) => {
                    roleStore.addRole(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }
        
        function update() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.put('/roles', role.value).then((response) => {
                    roleStore.updateRole(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }
        
        function remove() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.delete(`/roles/${role.value.id}`).then(() => {
                    roleStore.deleteRole(role.value);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }
        
        onMounted(() => {
            if (!props.addAction)
                findById($route.params.id);
            
        });
        
        return {
            roleStore,
            mxRules,
            dialog,
            loading,
            overlay,
            inputColor,
            backgroundColor,
            roleTypes,
            role,
            readonly,
            save,
            update,
            remove,
            getBack,
        };
    },
};
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="500"
    >
        <v-card>
            <w-dialog-toolbar
                :view-action="viewAction"
                :delete-action="deleteAction"
                :add-action="addAction"
                :update-action="updateAction"
           />
            <w-overlay
                :overlay="overlay"
                :loading="loading"
                :delete-action="deleteAction"
                @remove="remove"
                @cancel="overlay = false"
            />
            <v-card-text>
                <v-container fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12">
                                <strong>{{ $t('common.label') }} *</strong>
                                <w-text-field
                                    v-model="role.name"
                                    :readonly="readonly"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <strong>{{ $t('common.comment') }}</strong>
                                <w-simple-text-area
                                    v-model="role.description"
                                    :readonly="readonly"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-add
                    :show="addAction"
                    :loading="loading"
                    @press="save"
                />
                <w-btn-update
                    :show="updateAction"
                    :loading="loading"
                    @press="update"
                />
                <w-btn-delete
                    :show="deleteAction"
                    :loading="loading"
                    @press="overlay = true"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

